// in ./MovetoStockOutButton.js

import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { Button, Confirm, crudUpdateMany } from 'react-admin';

class MovetoStockOutButton extends Component {
    state = {
        isOpen: false,
    }

    handleClick = () => {
        this.setState({ isOpen: true });
    }

    handleDialogClose = () => {
        this.setState({ isOpen: false });
    };

    handleConfirm = () => {
        const { basePath, crudUpdateMany, resource, selectedIds } = this.props;
        crudUpdateMany(resource, selectedIds, { bulkRequest: "MovetoStockOut", changeToStockOut : true }, basePath)
        this.setState({ isOpen: true });
    };

    render() {
        return (
            <Fragment>
                <Button label="Move to Stocked Out" onClick={this.handleClick} />
                <Confirm
                    isOpen={this.state.isOpen}
                    title="Move to Stocked Out for Selected Items"
                    content="Do you want to move all selected items as Stocked Out?"
                    onConfirm={this.handleConfirm}
                    onClose={this.handleDialogClose}
                />
            </Fragment>
        );
    }
}

export default connect(undefined, { crudUpdateMany })(MovetoStockOutButton);

